import { dayjs } from '@2wunder/klarx-tool'
import KFormItem from 'app/components/Modules/Form/KFormItem'
import React, { useMemo } from 'react'

import { MemberProps } from '../../convention'
import GuaranteedTag from '../Availability/Guaranteed'

type Props = MemberProps<Pick<ILineItem, 'earliestAvailableDateTime'>>

const GuaranteedWrapper: React.FC<{ value?: string } & Props> = ({ member, value }) => {
  const startDate = useMemo(() => dayjs(value).parseLocaleDate(), [value])

  return <GuaranteedTag member={member} props={{ startDate }} />
}

const GuaranteedFormItem: React.FC<Props> = (props) => {
  return (
    <KFormItem name="startDate" hasFeedback={false} hideErrors={true} showLabel={false}>
      <GuaranteedWrapper {...props} />
    </KFormItem>
  )
}

export default GuaranteedFormItem
